import React from 'react';
import WName from '../WName';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, TLDR, Qual} from '../common';

// We need to impose hierarchy on everything

export const hierarchy = {
  name: "hierarchy",
  parentName: "our need to impose hierarchy",
  alternatives: "hierarchies,hierarchical",
  prelude: <span>
    It’s called ‘<NW>okugerocentrism</NW>’.
  </span>,
  header: <span>
    Humanity<sup>®</sup> needs <i>hierarchy</i>.
  </span>,
  outside: <span>
    Especially with <QL name="tm">that ®</QL>. The <NW>MNS system</NW> (of <LRL>reactivity</LRL> and <PL>radical mistrust</PL> cannot function without <QL>RigidBoxing</QL><sup>™</sup> everything into a <i>finite structure</i>.
  </span>,
  preview: <div className="problem-preview">
    <p>GET IN PLACE. Toe the line. Do <PL>ONLY</PL> what I tell you and FOLLOW ORDERS and <LRL name="kujifanya">DARE NOT TO IMAGINE</LRL> and you are only <PL>Safe</PL><sup>®</sup>.</p>
    <p>Hierarchy is emergent from finitude. <PL>infinity</PL> has no hierarchy. The set of all ordinals (Ω/big-omega) is an ordinal (1<sup>st</sup>, 2<sup>nd</sup>, 3<sup>rd</sup>, …, <i>n</i><sup>th</sup>, …, last) that’s both ‘last’ <i>and</i> sort of a φ-rule (‘fee-rule’) that’s simply ‘greater’ than everything. Including itself. Which leads to the <QL name="pratty.atomland">Atomlandly</QL>-<AL name="fields.logic.buffalo">baffling</AL> conclusion that {"∞ > ∞ ∧ ∞ < ∞ ∧ ∞ = ∞"}. (Read out <PL name="ch.">Uwa</PL>, ‘Infinity pointing-at infinity mountain infinity pointed-at-by infinity mountain infinity equals infinity.’ Infinity is greater than infinity and infinity is less than infinity and infinity equals infinity.)</p>
  </div>,
  text: <div className="problem-text">
    <p>So to impose a hierarchy (cf. <NW word="forca">força</NW>) is to choose <QL>RigidBoxing</QL><sup>™</sup> over <i><LRL name="understand">comprehension</LRL></i>. A <PL>nazi</PL> move: I do not try to understand the <AL>system</AL> (with <AL>you</AL> and my ‘<PL name="individuality">self</PL>’ as <i>parts</i> of it). I impose ‘order’ (as the <NW>LOC</NW>: lock it down) and don’t <i><PL name="ourself">realise</PL></i> that there is just as much <NW>entropy</NW> in complete homogeneity as in complete chaos. Because if everything looks the same then from any perspective within it you <i>don’t know where you are</i>, so agnosticity, so fear, so hide, so no one <i>knows</i>, so agnosticity, so <PL>FEAR</PL>, so… (cf. <NW word="jorm">Jörmungandr</NW>).</p>
  [under construction]
  </div>,
};
